import React from "react";
export default class RightToolbar extends React.Component {
  insertInput = () => {
    this.props.onEntityInsert("USER_INPUT", "SEGMENTED", {
      name: "",
      kind: "text",
      minWidth: "32px",
      width: "100px",
      minHeight: "24px",
    });
  };
  insertSelect = () => {
    this.props.onEntityInsert("USER_INPUT", "SEGMENTED", {
      minWidth: "32px",
      minHeight: "24px",
      width: "100px",
      name: "",
      kind: "select",
    });
  };
  insertCheck = () => {
    this.props.onEntityInsert("USER_INPUT", "SEGMENTED", {
      name: "",
      kind: "check",
      minWidth: "26px",
      minHeight: "24px",
      list: [{ name: "", default: false }],
    });
  };
  insertLink = () => {
    this.props.onEntityInsertInline("USER_LINK", "MUTABLE", {
      linkType: "url",
      kind: "link",
      linkTo: "",
    });
  };
  render() {
    return (
      <>
        <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 mt-4">
          <li className="nav-item mb-2">
            <button
              disabled={!this.props.editorFocused || this.props.selectedEntity}
              onMouseDown={(e) => {
                e.preventDefault();
                this.insertInput();
              }}
              className="btn btn-sm btn-icon btn-bg-light btn-hover-light-primary"
              title="Вставить Поле ввода"
            >
              <i className="fa fa-i-cursor"></i>
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              disabled={!this.props.editorFocused || this.props.selectedEntity}
              onMouseDown={(e) => {
                e.preventDefault();
                this.insertSelect();
              }}
              className="btn btn-sm btn-icon btn-bg-light btn-hover-light-primary"
              title="Вставить Выпадающий список"
            >
              <i className="flaticon2-sort-down"></i>
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              draggable={true}
              disabled={!this.props.editorFocused || this.props.selectedEntity}
              onMouseDown={(e) => {
                e.preventDefault();
                this.insertCheck();
              }}
              className="btn btn-sm btn-icon btn-bg-light btn-hover-light-primary"
              title="Вставить Галочки"
            >
              <i className="flaticon2-checkmark"></i>
            </button>
          </li>
          <li className="nav-item">
            <button
              draggable={true}
              disabled={!this.props.editorFocused || this.props.selectedEntity}
              onMouseDown={(e) => {
                e.preventDefault();
                this.insertLink();
              }}
              className="btn btn-sm btn-icon btn-bg-light btn-hover-light-primary"
              title="Вставить ссылку"
            >
              <i className="fa fa-link"></i>
            </button>
          </li>
        </ul>
      </>
    );
  }
}
